import { createContext } from "react";

const Usercontext = createContext(null)

export default Usercontext